import { GridRow, gridRowProps } from '@camelot/core';
import { GraphSchema } from '@camelot/server';

export interface QuotationGridRow extends GridRow {
  documentCount: number;
  documentIds: string[];
  marketType: number | null;
  rowPricingType: number | null;
  vatLevelId: number | null;
}

const props: (keyof QuotationGridRow)[] = [
  'documentCount',
  'documentIds',
  'marketType',
  'rowPricingType',
  'vatLevelId',
];

export const quotationGridRowProps = new GraphSchema<QuotationGridRow>(props.concat(gridRowProps));
